import { Dictionary } from "@/lib/Dictionary.type";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";

import BulkShipmentBox from "./bulk-shipment-box.model";

export default class BulkShipmentBoxRepository extends BasicRepository<BulkShipmentBox> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<BulkShipmentBox>,
    responseParser: ApiCollectionResponseParserService<BulkShipmentBox>
  ) {
    super("bulk_shipment_boxes", api, objectBuilder, responseParser);
  }

  protected prepareData(item: BulkShipmentBox): Dictionary<string | number> {
    const data: Dictionary<string | number> = {
      id: item.id,
      boxNumber: item.boxNumber,
      length: item.length,
      width: item.width,
      height: item.height,
      weight: item.weight,
    };

    return data;
  }
}
